module.exports = __webpack_public_path__ + "static/media/logo.92210e84.png";